import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, UserLogin } from 'ngx-sds-login';
import { Observable, Subject, combineLatest, takeUntil } from 'rxjs';
import { Pagination } from 'src/app/infraestructure/interfaces/pagination/pagination.DTO';
import { ParametersDTO } from 'src/app/infraestructure/interfaces/parameters/ParametersDTO';
import { CambiarEstadoVehiculoI } from 'src/app/infraestructure/models/cambiarEstadoVehiculo';
import { VehiculoInternoI } from 'src/app/infraestructure/models/consultaVehiculoInterno';
import { ConsultarConductoresI } from 'src/app/infraestructure/models/consultarConductores';
import { PaginationI } from 'src/app/infraestructure/models/pagination.interface';
import { ParametricListsService } from 'src/app/infraestructure/services/parametric-lists/parametric-lists.service';
import { ProgrammerApiService } from 'src/app/infraestructure/services/programmer/programmer-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-gestion-vehiculos-internos',
  templateUrl: './gestion-vehiculos-internos.component.html',
  styleUrls: ['./gestion-vehiculos-internos.component.scss']
})
export class GestionVehiculosInternosComponent implements OnInit, OnChanges {

  @Output() habilitGuardar = new EventEmitter<boolean>();
  @Output() dataVehiculoInterno = new EventEmitter<CambiarEstadoVehiculoI>();
  @Output() liberarVehiculoInterno = new EventEmitter<any>();

  @Input() guardar: number = 0;
  @Input() solicitudID: number = 0;
  @Input() reloadTable: number = 0;

  $parametricList: ParametersDTO = new ParametersDTO();
  private $topSubcription = new Subject<void>();
  paginationResponse = {} as PaginationI;
  paginationRequest: Pagination = new Pagination();
  user$: Observable<UserLogin>;
  dataTable: VehiculoInternoI[] = [];
  conductores: ConsultarConductoresI[] = [];
  actualizarVehiculo = {} as CambiarEstadoVehiculoI;

  claseVehiculoSeleccionada: any;
  rolId: number = 0;
  valueChecked: number = 0;

  constructor(private _listSrv: ParametricListsService,
              private programmerApiSrv: ProgrammerApiService,
              private store: Store<AppState>,) { 
                this.user$ = this.store.select(state => state.user);
                this.user$.subscribe(user => {
                  this.rolId = user.rolId;
                });
               }

  ngOnInit(): void {
    combineLatest(
    this._listSrv.getDataLists('TIP_CLASE_VEHICULO'),
    this.programmerApiSrv.postObtenerConductoresPorTipo(true)
    )
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(([
        Data1, Data2
      ]: any) => {
        if (Data1.code === 200) {
          this.$parametricList.typeKindVehicle = Data1.data;
        }
        if (Data2.code === 200) {
          this.conductores = Data2.data;
        }
      });

      this.paginationRequest.itemsPorPagina = 5;
      this.paginationRequest.numeroPagina = 1;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['guardar'] && this.guardar !== 0) {
      this.onGuardar();
    }

    if (changes['reloadTable'] && this.reloadTable !== 0) {
      this.onSelectedKindVehicle(this.paginationRequest);
    }
  }

  onSelectedKindVehicle(paginationReq: Pagination) {
    if (paginationReq) {
      this.paginationRequest.itemsPorPagina = paginationReq.itemsPorPagina;
      this.paginationRequest.numeroPagina = paginationReq.numeroPagina;
    }

    this.paginationRequest.solicitudId = this.solicitudID;
    this.paginationRequest.claseId = this.claseVehiculoSeleccionada;

    this.programmerApiSrv.postObtenerVehiculosPorClase(this.paginationRequest)
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(res => {
      this.paginationResponse = {
        itemsPage: res.data.itemsPage,
        page: res.data.number,
        pages: res.data.pages
      }

      this.dataTable = res.data.data;
    });
  }

  onSelectedCheck(event: any) {
    const item: number = Number((event.target as HTMLInputElement).value);
    const check: boolean = (event.target as HTMLInputElement).checked;
    
    this.habilitGuardar.emit(check);
    if (item < 1 || !check) return;
    this.valueChecked = item;
  }

  onSelectedConductor(event: Event) {
    const CONDUCTOR_ID: number = Number((event.target as HTMLInputElement).value);
    this.actualizarVehiculo.conductorId = CONDUCTOR_ID;
  }

  liberarVehiculo(idVehiculo: number, conductorId: number,solicitudId: number) {
    this.liberarVehiculoInterno.emit({'vehiculoId': idVehiculo, 'conductorId': conductorId, 'solicitudId': solicitudId});
  }

  onGuardar() {
    this.actualizarVehiculo.vehiculoId = this.valueChecked;
    this.actualizarVehiculo.bEsVehiculoInterno = true;
    
    this.dataVehiculoInterno.emit(this.actualizarVehiculo);
  }
}
